import { Payment, PaymentPlans } from "@finway-group/shared/lib/models"
import axios from "axios"

const MODEL = "payment"

const StripeService = {
    fetchPaymentSettings: async () => {
        const { data } = await axios.get(`/${MODEL}`)
        return data as Payment
    },
    createPaymentSettings: async (updateData: Payment) => {
        const { data } = await axios.post(`/${MODEL}`, updateData)
        return data
    },
    updatePaymentSettings: async (updateData: Payment) => {
        const { data } = await axios.put(`/${MODEL}`, updateData)
        return data
    },
    deletePaymentSettings: async () => axios.delete(`/${MODEL}`),
    fetchLatestInvoiceLink: async () => {
        const { data } = await axios.get(`${MODEL}/latest_invoice`)
        return data.invoice_link
    },
    cancelPaymentSubscription: async () => axios.get(`${MODEL}/cancel`),
    reactivatePaymentSubscription: async () => axios.get(`${MODEL}/reactivate`),
    fetchPaymentPlans: async () => {
        const { data } = await axios.get(`/${MODEL}/plans`)
        return data as PaymentPlans
    },
}

export default StripeService
